<!-- @veltra/icons generated sha256:e509d3fc5079e0d8 gen:8 source:src/svg/normal/login.svg -->
<script setup lang="ts">
defineOptions({ name: 'Login' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M4 3v1.49a.51.51 0 0 1-.496.51A.5.5 0 0 1 3 4.507V2.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-2.007c0-.276.228-.493.496-.493.276 0 .504.234.504.51V13h8V3zm2.576 2.599L8.477 7.5H1.498a.5.5 0 0 0 0 1h6.98l-1.902 1.901a.477.477 0 0 0-.001.688l.008.008a.505.505 0 0 0 .71 0l2.744-2.742a.503.503 0 0 0 0-.71L7.294 4.902a.505.505 0 0 0-.711.001l-.008.008a.477.477 0 0 0 .001.688"
    />
  </svg>
</template>
